<template>
	<div class="header__links-item header__user" :data-count="notifications?.count || 0">
		<a class="header__links-btn header__user-btn" href="/personal/">
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" clip-path="url(#a)"><path d="M2 15.5c0-2.21 2.686-4 6-4s6 1.79 6 4M8 9.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"></path></g><defs><clipPath id="a"><path fill="#fff" d="M0 .5h16v16H0z"></path></clipPath></defs></svg>
			<span>Личный кабинет</span>
		</a>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'PersonalLinks',
	computed: {
		...mapGetters({
			notifications: 'notifications/getNotifications',
		})
	},

}
</script>